import Vue from 'vue';
import Vue2TouchEvents from 'vue2-touch-events';
import Icon from '@components/global/Icon';
import Arrow from '@components/global/Arrow';
import ResponsiveImage from '@components/global/ResponsiveImage';
import ResponsiveBackground from '@components/global/ResponsiveBackground';
import ResponsiveVideo from '@components/global/ResponsiveVideo';
import moment from 'moment';
import VeeValidate from 'vee-validate';
import VueInView from 'vueinview';

import App from '@/App.vue';
import i18n from '@config/i18n/i18n';
import router from '@config/router/router';
import store from '@config/store/store';

import VueMeta from 'vue-meta'

import '@assets/scss/style.scss';

Vue.config.productionTip = false;

Vue.use(Vue2TouchEvents, {
  swipeTolerance: 150,
});

Vue.use(VueInView);
VueInView.offset(50)

Vue.use(VeeValidate);

Vue.use(VueMeta)

Vue.component('Icon', Icon);
Vue.component('Arrow', Arrow);
Vue.component('responsive-image', ResponsiveImage);
Vue.component('responsive-background', ResponsiveBackground);
Vue.component('responsive-video', ResponsiveVideo);

Vue.filter('formatDate', function(value) {
  if (!value) return '';
  return moment(String(value)).format('DD/MM/YYYY');
});

export default new Vue({
  i18n,
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
